import React from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { useQuery, useMutation, gql } from '@apollo/client';
import { Spinner } from 'equasion-lib';
import ApiError from '@/lib/shared-coms/ApiError';
import UnserializedStocking from './UnserializedStocking';
import { useRootStore } from '@/lib/providers/RootProvider';

const PURCHASE_ORDER = gql`
  query purchaseOrder($id: ID!, $clientId: ID!) {
    purchaseOrder(id: $id, clientId: $clientId) {
      id
      clientPurchaseOrderNumber
      orderItems {
        id
        productId
        quantity
        product {
          id
          title
          fdaProduct {
            id
            name
            elevenDigitNdc
            deaSchedule
          }
          upcProduct {
            id
            upc
          }
        }
      }
      vendor {
        id
        companyName
        locations {
          id
          type
          address {
            lineOne
            city
            state
          }
        }
      }
    }
  }
`;

const STOCK_UNSERIALIZED_PURCHASE_ORDER = gql`
  mutation stockUnserializedPurchaseOrder(
    $id: ID!
    $inventoryEvents: [InventoryEventAttributes!]!
    $companyId: ID!
  ) {
    stockUnserializedPurchaseOrder(
      id: $id
      inventoryEvents: $inventoryEvents
      companyId: $companyId
    ) {
      id
    }
  }
`;

function UnserializedStockingData(props) {
  const clientId = useRootStore((state) => state.selectedCompany.id);
  const [stockUnserializedPurchaseOrder] = useMutation(STOCK_UNSERIALIZED_PURCHASE_ORDER);
  const { purchaseOrderId } = useParams();
  const { data, error, loading, refetch } = useQuery(PURCHASE_ORDER, {
    variables: { id: purchaseOrderId, clientId: clientId }
  });

  if (loading) return <Spinner />;
  if (error) return <ApiError error={error} />;

  const { purchaseOrder } = data || {};

  return (
    <UnserializedStocking
      purchaseOrder={purchaseOrder}
      stockUnserializedPurchaseOrder={stockUnserializedPurchaseOrder}
      clientId={clientId}
      refetch={refetch}
      {...props}
    />
  );
}

export default UnserializedStockingData;
